export const DeleteLeadsContactFilter = Object.freeze({
  CUSTOM: 'CUSTOM',
  CRM: 'CRM',
})

export const ReadableDeleteLeadsContactFilter = Object.freeze({
  CUSTOM: 'delete-leads.custom-filter',
})
